var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import styles from './Header.module.css';
import Burger from '../Burger';
import Menu from './Menu';
export default function Header(_a) {
    var title = _a.title, contents = _a.contents, children = _a.children;
    var _b = __read(React.useState(false), 2), isMenuVisible = _b[0], setIsMenuVisible = _b[1];
    React.useEffect(function () {
        if (isMenuVisible) {
            document.documentElement.classList.add('modal-open');
        }
        else {
            document.documentElement.classList.remove('modal-open');
        }
    }, [isMenuVisible]);
    return (React.createElement(React.Fragment, null,
        React.createElement("header", { className: styles.header },
            children,
            contents && !!contents.length && (React.createElement(Burger, { on: isMenuVisible, onClick: function () { return setIsMenuVisible(!isMenuVisible); } }))),
        contents && !!contents.length && (React.createElement(Menu, { title: title, contents: contents, visible: isMenuVisible, close: function () { return setIsMenuVisible(false); } }))));
}
